import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		female: {
			// /f?safe&mock-data&utm_source=FB&country=US&area=female&exp=web_fasting_f_improve_copy~1
			funnel: {
				id: 'ob-female-funnel-improve-copy',
				locale: ['en'],
			},
		},
	},
]

export default config
